import loadable from '@loadable/component';

import { CmsApiGradCtaHeroBlockData } from 'modules/cms/api/types/blocks/CmsApiGradCtaHeroBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsGradCtaHeroBlockMapping: CmsBlockMapping<CmsApiGradCtaHeroBlockData> =
  {
    invariant: [
      {
        prop: 'text',
        msg: 'Text data required for call to action',
      },
      {
        prop: 'image',
        msg: 'Image data required for call to action',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsGradCtaHeroBlock'), {
        resolveComponent: (module) => module.CmsGradCtaHeroBlock,
      }),
    ),
    AmpComponent: loadable(() => import('./CmsAmpGradCtaHeroBlock'), {
      resolveComponent: (module) => module.CmsAmpGradCtaHeroBlock,
    }),
  };
